import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import breakpoints from '@repo/ui-components/breakpoints';
import Article from './Article';

const ArticleWrapper = styled.div`
  display: grid;
  grid-template: 1fr / 1fr;
  grid-gap: 0.625rem;
  @media (min-width: ${breakpoints.sm}) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: ${breakpoints.md}) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 1.5625rem;
  }
`;

const Articles = ({ articles }) => (
  <ArticleWrapper>
    {articles.map(article => (
      <Article key={article.title} article={article} />
    ))}
  </ArticleWrapper>
);

Articles.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default Articles;
